import WarningIcon from '@mui/icons-material/Warning'
import { Tooltip, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { formatDate } from '@tom-ui/utils'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { isValidityExpiredByNow } from '@planning/utils/release-validity-utils'

interface Props {
  validityDate?: string | null
}
export const ReleaseValidityDate = observer(({ validityDate }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  if (!validityDate) {
    return EmptyIndicator
  }

  const validityDayjs = dayjs(validityDate)

  return (
    <Stack direction='row' alignItems='center' spacing={theme.customSpacing.s}>
      <Typography variant='body2'>{formatDate(validityDate)}</Typography>
      {isValidityExpiredByNow(validityDayjs) && (
        <Tooltip title={t('expired', 'Expired')} placement='top' arrow>
          <WarningIcon color='warning' />
        </Tooltip>
      )}
    </Stack>
  )
})
